// @flow

export function maxValue (array: Array<number>): number {
    //  return array.reduce(function(a, b) {
    //     return Math.max(a, b);
    //  });

    // var len = arr.length, max = -Infinity;
    // while (len--) {
    //     if (arr[len] > max) {
    //         max = arr[len];
    //     }
    // }
    // return max;

    return Math.max.apply(null, array);
}

export function scale (val: number, height: number, max: number): number {
    const k = height / max;
    return height - Math.floor(val * k);
}

export function xStep (array: Array<number>, size: number) {
    return size / (array.length - 1);
}
